import { MdDialogRef } from '@angular/material';
import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EntityEmailService } from 'app/entities/emails/emails.service';
import { UserPreferencesService } from '../../../header/usersettings/userpreferences/user-preferences.service';
import { CookieService } from 'app/services/cookie.service';
import { ConstantsService } from 'app/services/constants-service';
import { SnackBarService } from 'app/services/snackbar.service';
import { MessageService } from 'app/services/messages.service';
import { Email } from 'app/entities/emails/emails-model';
import { OrganisationalEmail } from 'app/entities/emails/emails-model';
import { EntityIdDetails } from 'app/shared/models/entity-id-details.model';
import { EntityDetailsService } from 'app/entities/details/entity-details.service';
import { OnChanges } from '@angular/core/src/metadata/lifecycle_hooks';
import { plainToClass } from 'class-transformer';

@Component({
    templateUrl: 'import-email.component.html',
    providers: [UserPreferencesService],
    styleUrls: ['import-email.component.css']
})
export class ImportEmailComponent implements OnInit, OnChanges {
    entityIdDetails: EntityIdDetails;
    emailLoginForm: FormGroup;
    emails: Email[] = [];
    selectedEmail: Email;
    checkedEmail: Email[] = [];
    loginModel: any;

    isEmailLoading = false;
    loginLoader = false;

    isRecordNumberMoreThanLimit = true;
    maxRecordsToBeDisplayed = 10;
    currentEmailRecords = 0;
    numberOfEntries = 0;
    totalMessagesFetchedFromEmailAccount = false;

    constructor(
        public dialogRef: MdDialogRef<any>,
        private userPrefService: UserPreferencesService,
        private cookieService: CookieService,
        private formBuilder: FormBuilder,
        public entityDetailsService: EntityDetailsService,
        public entityEmailService: EntityEmailService,
        private snackBarService: SnackBarService
    ) { }

    createForm() {
        this.emailLoginForm = this.formBuilder.group({
            email: ['', Validators.required],
            password: ['', Validators.required],
        });

    }

    ngOnInit() {
        this.entityIdDetails = this.entityDetailsService.getEntityIdDetails();
        this.createForm();
        this.userPrefService
            .getUserPreferences(this.cookieService.get(ConstantsService.COOKIE_LOGIN_USER_NAME))
            .subscribe(response => {
                this.emailLoginForm.patchValue({
                    email: response.email
                })
            });
    }

    onSubmit({ value, valid }) {
        this.loginLoader = true;
        this.loginModel = Object.assign({}, value);
        this.getRemotEmails();
    }

    selectEmail(email) {
        this.selectedEmail = email;
    }

    updateCheckedEmails(email, event) {
        if (event.target.checked) {
            this.checkedEmail.push(email);
        } else {
            this.checkedEmail = this.checkedEmail.filter(item => item !== email);
        }

    }

    importEmails() {
        this.loginLoader = true;
        const encodedString = this.entityEmailService.getEncodedString(this.loginModel.password);
        const organisationalEmail = new OrganisationalEmail();

        organisationalEmail.emails = this.checkedEmail;
        organisationalEmail.password = encodedString;
        organisationalEmail.entityId = this.entityIdDetails.entityId;

        this.entityEmailService.saveEmailsInDatabase(organisationalEmail).subscribe(response => {
            if (response.flagResult) {
                this.loginLoader = false;
                this.dialogRef.close();
                this.callSnackBarService(response, MessageService.EMAILS_IMPORT_SUCCESSFULL, MessageService.EMAILS_RETREIVED_FAILURE);
            } else {
                this.callSnackBarService(response, MessageService.EMAILS_IMPORT_SUCCESSFULL, MessageService.EMAILS_RETREIVED_FAILURE);
            }
        }, err => {
            this.loginLoader = false;
            this.callSnackBarService(err, "", MessageService.GENERIC_ERROR);
        });
    }

    ngOnChanges() {
        this.getRemotEmails();
    }

    getRemotEmails() {
        if (!this.totalMessagesFetchedFromEmailAccount) {
            if (!this.loginLoader) {
                this.isEmailLoading = true;
            }
            this.entityEmailService.getRemoteEmails(this.loginModel.password, this.currentEmailRecords, this.maxRecordsToBeDisplayed)
                .subscribe(response => {
                    if (response.flagResult) {
                        const emails = plainToClass(Email, response.arrResult as Object[]);
                        if (emails.length > 0) {
                            this.emails = this.emails.concat(emails);
                            if (!this.selectedEmail) {
                                this.selectedEmail = this.emails[0];
                            }
                            this.isEmailLoading = false;
                        } else {
                            this.callSnackBarService(response, MessageService.NO_MORE_EMAILS_TO_RETREIVE, "");
                            this.totalMessagesFetchedFromEmailAccount = true;
                        }
                    } else {
                        this.callSnackBarService(response, "", MessageService.EMAILS_FAILED_TO_CONNECT);
                    }
                    this.loginLoader = false;
                }, err => {
                    this.callSnackBarService(err, "", MessageService.GENERIC_ERROR);
                });
        }
    }
    onScrollDown() {
        this.currentEmailRecords = this.emails.length;
        this.getRemotEmails();
    }

    callSnackBarService(response: any, successMsg: string, failureMsg: string) {
        this.isEmailLoading = false;
        this.snackBarService.showStatus(response, successMsg, failureMsg);
    }

}



// WEBPACK FOOTER //
// ./src/app/entities/emails/import-email/import-email.component.ts